import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as Back from './utils/back'
import "./utils/rem.js";
// import './utils/vconsole.js'

import JsBridge from "./utils/JsBridge"
Vue.prototype.$jsbridge = JsBridge;


import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";


//全局引入store
import {
	UPDATE_LOAD_SHOW,
	UPDATE_LOAD_TEXT,
	UPDATE_LOAD_SHOW_LEVEL,
	RESET_LOAD_SHOW_LEVEL,
	ADD_NEW_QUICK_SIGN_FILES,
	ADD_SOURCE_FLAG
} from "./store/types.js";

import {
	Tool
} from "./utils/Tool.js";

Vue.prototype.$store = store;
Vue.prototype.$LoadShow = UPDATE_LOAD_SHOW;
Vue.prototype.$LoadText = UPDATE_LOAD_TEXT;
Vue.prototype.$LoadShowLevel = UPDATE_LOAD_SHOW_LEVEL;
Vue.prototype.$addQuickSignFiles = ADD_NEW_QUICK_SIGN_FILES;
Vue.prototype.$addSourceFlag = ADD_SOURCE_FLAG;

Vue.prototype.Tool = Tool;

//全局引入组件
import {
	Toast,
	Popup,
	Overlay,
	Loading,
} from "vant";
//import 'vant/lib/index.css';
Vue.use(Toast).use(Popup).use(Overlay).use(Loading);
Toast.setDefaultOptions({
	duration: 2000
})
Vue.prototype.$Toast = Toast;

// 封装请求
import {
	POST,
	GET,
	SEALP,
	SEALPS,
	SEALG
} from './utils/http';
Vue.prototype.$post = POST;
Vue.prototype.$get = GET;
Vue.prototype.$sealp = SEALP;
Vue.prototype.$sealps = SEALPS;
Vue.prototype.$sealg = SEALG;

// baseurl 全局引入
import {
	baseurl
} from './utils/url';
Vue.prototype.$baseurl = baseurl;

// 公用组件全局注册
import {
	erHeader,
} from "./components";

Vue.component("myheader", erHeader);

document.cookie = ''

//初始化登录信息
let loginInfo = window.localStorage.getItem("LoginInfo")
if (loginInfo) {
	//console.log('初始化登录信息')
	store.commit("changeLoginInfo", JSON.parse(loginInfo));
}

// 解决路由报错
import Router from 'vue-router'
import contractBlockchainCertificateInfoVue from './views/contract/contractBlockchainCertificateInfo.vue'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false

// 路由切换控制
const pathHistory = window.sessionStorage;
pathHistory.clear();
//console.log('sessionStorage clear')
let historyCount = pathHistory.getItem("pathCount") * 1 || 0;
pathHistory.setItem("/", 0);
router.beforeEach(function(to, from, next) {
	console.log('router-for-to-=', router, from, to)
	console.log('router-for-to-=', from.fullPath, to.fullPath)

	const toIndex = pathHistory.getItem(to.fullPath);
	const fromIndex = pathHistory.getItem(from.fullPath);

	const token = window.localStorage.getItem("Identity_Token")

	const homeUrl = window.localStorage.getItem("HomeUrl")

	const home = homeUrl || '/home'
	//store.commit("changeLoginToken", token);
	//调用遮罩层后切换页面 
	store.dispatch(RESET_LOAD_SHOW_LEVEL, 0)
	//store.dispatch(UPDATE_LOAD_SHOW, false)
	//store.state.loadShowLevel = 0

	// 路由重定向
	// if (to.path === '/home' && from.path === '/newquicksign' && !to.query.files) {
	// 	console.log('router-for-to-13=',  from.fullPath, to.fullPath)
	// 	next({
	// 		path: '/home'
	// 	})
	// }
	if (to.path === "/home" && to.query.files) {
		console.log('router-for-to-newquicksign=', to.query.files)
		store.dispatch(ADD_NEW_QUICK_SIGN_FILES, to.query.files)
		to.query.files = ''
		if (from.path === '/newquicksign') {
			next({
				path: '/home'
			})
		}
	}
	if (to.path === "/home" && to.query.infos) {
		console.log('router-for-to-contractDetails=', to.query.infos)
		store.dispatch('actionQuickSignContractDetails', to.query.infos)
		//to.query = {}
		if (from.path === '/contractdetails') {
			next({
				path: '/home'
			})
		}
		// next({
		// 	path: '/contractdetails',
		// 	query: {
		// 		contractId: infos[0],
		// 		contractStatus: infos[1],
		// 		t: Date.now()
		// 	}
		// })
	}
	// if (from.path !== "/newquicksign" && from.query.files) {
	// 	console.log('router-for-to-11=', from.fullPath, to.fullPath)
	// 	to.query.files = from.query.files
	// }
	if (from.path === "/") {
		console.log('router-for-/-to=', token, from.fullPath, to.fullPath)
		if (to.path !== '/login' && to.path !== '/logon' && to.path !== '/agreementdetails' && to.path !== '/faceauth' && to.path !== home) {
			if (token) {
				next({
					path: home,
				});
			} else {
				next({
					path: '/login',
				});
			}
		}
		if (to.path === home && to.path !== '/agreementdetails' && !token) {
			next({
				path: '/login',
			});
		}
		if (to.path === '/register' || to.path === '/forgot') {

		}
	}
	if (from.path === "/login") {
		console.log('router-for-login-to=', token, from.fullPath, to.fullPath)
		if (to.path !== '/login' && to.path !== home && to.path !== '/register' && to.path !== '/forgot' && to
			.path !== '/agreementdetails') {
			if (token) {
				next({
					path: home,
				});
			} else {
				next({
					path: '/login',
				});
			}
		}
		if (to.path === home && !token) {
			next({
				path: '/login',
			});
		}
	}
	// if (to.path !== '/login' && to.path !== home) {
	// 	console.log('router-for-to-12=', token, from.fullPath, to.fullPath)
	// 	if (token) {
	// 		next({
	// 			path: home,
	// 		});
	// 	} else {
	// 		next({
	// 			path: '/login',
	// 		});
	// 	}
	// }
	// if (to.path === home && !token) {
	// 	console.log('router-for-to-13=', token, from.fullPath, to.fullPath)
	// 	next({
	// 		path: '/login',
	// 	});
	// }
	//跳转重新登录后historyCount为0
	if (from.path === '/settings' && to.path === '/login') {
		historyCount = 0
	}
	// 用于控制路由切换动作
	//console.log(toIndex, fromIndex)
	if (toIndex) {
		//console.log('toIndex', typeof toIndex, typeof fromIndex)
		if (
			!fromIndex ||
			parseInt(toIndex, 10) > parseInt(fromIndex, 10) ||
			(toIndex === "0" && fromIndex === "0")
		) {
			store.commit("UPDATE_DIRECTION", {
				direction: "forward"
			});
		} else {
			store.commit("UPDATE_DIRECTION", {
				direction: "reverse"
			});
			pathHistory.removeItem(from.fullPath);
		}
	} else {
		// console.log('historyCount', historyCount)
		++historyCount;
		pathHistory.setItem("pathCount", historyCount)
		to.path !== "/" && pathHistory.setItem(to.fullPath, historyCount)
		//to.path === "/" && console.log('to', to.path !== "/")
		store.commit("UPDATE_DIRECTION", {
			direction: "forward"
		});
	}
	next()
});

//获取鸿蒙系统pdf文件分享
window.setHarmonyShareFile = function(files) {
	console.log('setHarmonyShareFile--=', files, router)
	if (files) {
		//const filearr = JSON.parse(files)
		const pageRules = ['/login', '/register', '/forgot', '/agreementdetails']
		store.dispatch('actionHarmonyShareFiles', files)
		if (!pageRules.includes(router.history.current.path)) {
			router.push({
				path: '/home',
				query: {
					t: Date.now()
				}
			})
		}
	}
	return true
}




//获取鸿蒙系统pdf文件分享
window.setIosShareFile = function(files) {
	console.log('setIosShareFile--=', files)
	return true
}

JsBridge.registerHandler("onEsignResult", function(data, responseCallback) {
	console.log('onEsignResult-1', data,responseCallback)
	if (responseCallback) {
		responseCallback("12345678")
		//console.log('setIosShareFileHandler', file.base64Content.length)
	}
});

window.onEsignResult = function(){
	console.log('onEsignResult-2', "12345678")
	return "12345678"
}


new Vue({
	router,
	store,
	Back,
	render: h => h(App)
}).$mount('#app')